import React from 'react';
import { PolicyFromText } from '../../components/ui/PolicyFromText';
import { returnsPolicy } from '../../data/policies/returns';
export function Returns() {
  return <PolicyFromText doc={returnsPolicy} data-id="element-1132" data-mp="227sma5ghh4d3" />;
}